import PropTypes from 'prop-types';

export const FlightTicketPropType = PropTypes.shape({
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  lastName2: PropTypes.string,
  dateOfBirth: PropTypes.string,
  phone: PropTypes.string,
  gender: PropTypes.string,
  staffSourceMarket: PropTypes.string,
  staffSourceMarketBudget: PropTypes.string,
  season: PropTypes.string,
  country: PropTypes.string,
  destination: PropTypes.string,
  jobTitle: PropTypes.string,
  iataCode: PropTypes.string,
  preferredFlightDate: PropTypes.string,
  typeOfFlight: PropTypes.string,
  status: PropTypes.string,
  followingStatus: PropTypes.string,
  confirmedStatus: PropTypes.string,
  isBookReturnFlight: PropTypes.bool,
  brfReturnFlightDate: PropTypes.string,
  brfDepartureAirport: PropTypes.string,
  brfArrivalAirport: PropTypes.string,
  isHotelNeeded: PropTypes.bool,
  departureAirports: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  arrivalAirports: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  isRailAndFly: PropTypes.bool,
  homeTrainStationName: PropTypes.string,
  noFlightNeeded: PropTypes.bool,
  staffLuggage: PropTypes.string,
  plannedAssignmentStartDate: PropTypes.string,
  dateRequested: PropTypes.string,
  created: PropTypes.string,
  createdBy: PropTypes.string,
  assignmentType: PropTypes.string,
  ecPositionId: PropTypes.string,
  sliceId: PropTypes.number,
  workingCountry: PropTypes.string,
  departmentLabel: PropTypes.string,
  workingLocationLabel: PropTypes.string,
  flights: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      flightNumber: PropTypes.string,
      via: PropTypes.string,
      confirmedFlightDate: PropTypes.string,
      flightDepartureTime: PropTypes.string,
      flightArrivalTime: PropTypes.string,
      hotelCheckInDate: PropTypes.string,
      hotelCheckOutDate: PropTypes.string,
    })
  ),
  comments: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      text: PropTypes.string,
      createdBy: PropTypes.string,
      group: PropTypes.string,
      created: PropTypes.string,
    })
  ),
  attachments: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      name: PropTypes.string,
      createdBy: PropTypes.string,
      created: PropTypes.string,
    })
  ),
});

export const FlightTicketListPropType = PropTypes.arrayOf(FlightTicketPropType);
